import { SELECT_TAB, TabState, TabActionTypes } from "./types";

const initialState: TabState = "topics";

export const tabReducer = (
  state = initialState,
  action: TabActionTypes,
): TabState => {
  switch (action.type) {
    case SELECT_TAB:
      return action.payload;
    default:
      return state;
  }
}
